const ERAS = [
  "1900s Victorian Brass",
  "1950s Teak Mid-Century",
  "1970s Silk Scarves",
  "1980s Archival Denim",
  "1990s Statement Jackets",
  "Under Construction — Opening Soon",
];

export default function EditorialMarquee() {
  const row = [...ERAS, ...ERAS];
  return (
    <section
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[#E2D9CD] bg-[#F3EFE6] py-5"
      aria-label="Vintage eras ticker"
    >
      <div data-testid="marquee-content" className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center whitespace-nowrap">
                <span className={`px-8 ${item.startsWith("Under") ? "font-mono text-xs uppercase tracking-[0.3em] text-[#6B1D2F]" : "font-serif text-xl italic text-[#1C1815]/80"}`}>
                  {item}
                </span>
                <span className="text-sm text-[#C59B27]">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
